import { COUNTRIES_BY_CODE } from "@redotech/locale/countries";
import { fgFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import GlobeIcon from "@redotech/redo-icons/globe-06.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import {
  AdvancedTableFilter,
  ArrayStringTableFilter,
} from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.countries;

export const CountriesFilter = (
  fetcher: (
    { filters }: { filters: AdvancedTableFilter[] },
    signal: AbortSignal,
  ) => Promise<string[]>,
): ArrayStringTableFilter<string> => ({
  type: entry.type,
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "country",
  itemLabelPlural: "countries",
  Icon: GlobeIcon,
  operators: [...entry.operators],
  valueFetcher: fetcher,
  display(item: string) {
    return COUNTRIES_BY_CODE[item] ?? item;
  },
  displayName: entry.displayName,
});
